<template>
  <div class="middle-bar animated fadeInLeftBig">
    <div class="mainDiv">
      <div class="b-line"></div>
      <div v-for="(item, i) in navList" :key="i">
        <div class="flex">
          <div class="bf" :class="i === active ? 'active' : ''"></div>
          <div
            class="item"
            :class="i === active ? 'active' : ''"
            @click="onChange(i)"
          >
            {{ item.name }}
          </div>
        </div>
        <template v-if="i === active">
          <div class="flex sub" v-for="(it2, i2) in item.children" :key="i2">
            <div class="bf" :class="it2.active === true ? 'active' : ''"></div>
            <div
              class="item"
              :class="it2.active === true ? 'active' : ''"
              @click="onChange2(i2)"
            >
              {{ it2.name }}
            </div>
          </div>
        </template>
      </div>
    </div>
  </div>
</template>

<script>
import { lchooseMixin } from "@/util/mixin/lchooseMixin";
export default {
  mixins: [lchooseMixin],
  data() {
    return {
      navList: [
        // {
        //   name: "经营主体分布"
        // },
        {
          name: "种植分布",
          children: [
            {
              active: true,
              name: "荔枝"
            },
            {
              active: false,
              name: "龙眼"
            },

            {
              active: false,
              name: "香蕉"
            }
          ]
        },
        {
          name: "农机分布"
        },
        {
          name: "涉农企业",
          children: [
            {
              active: true,
              name: "龙头企业"
            },
            {
              active: false,
              name: "合作社"
            },
            {
              active: false,
              name: "家庭农场"
            },
            {
              active: false,
              name: "农资经营企业"
            },
            {
              active: false,
              name: "生产基地"
            }
          ]
        }
      ]
    };
  }
};
</script>

<style lang="stylus" scoped>
@import '~styl/granary/choose'
</style>
